function observerInit() {
	var IntersectionObserverCallback = function(entries) {
		entries.forEach((entry, i) => {
			if (entry.isIntersecting) {
				entry.target.dataset.visible = "true";
			}
		});
	};

	var IntersectionObserverOptions = {
		root: null,
		rootMargin: "0px",
		threshold: 0.8,
	};

	var observer = new IntersectionObserver(
		IntersectionObserverCallback,
		IntersectionObserverOptions
	);

	window.addEventListener("load", function(e) {
		var targets = document.querySelectorAll(
			`[data-observable],

			.about-partners h2,
			.about-partners__img,

			.documents-preview header,
			.documents-preview__img,
			.documents-preview__link,

			.industrial-delivery__card,

			.recipes-content__tags,
			.recipe-card,

			.industrial-img-with-text__text,
			.our-chronology h2,
			.our-chronology li,
			.footer-logo,
			.about-production header,
			.about-karaoke__text h2,
			.about-karaoke__img,
			.additional-text h2,
			.industrial-category-item__text h2,
			.industrial-category-item__list
			`
		);
		targets.forEach((target) => {
			target.dataset.visible = "false";
			observer.observe(target);
		});
	});
}
